import { Component } from '@angular/core';
import { faWhatsapp, faXTwitter, faFacebook, faInstagram, faTiktok, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  standalone: false,
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  contact = environment.contact;
  developerUrl = environment.developerUrl;

  faWhatsapp = faWhatsapp;
  faXTwitter = faXTwitter;
  faFacebook = faFacebook;
  faInstagram = faInstagram;
  faTiktok = faTiktok;
  faYoutube = faYoutube;
  faEnvelope = faEnvelope;
}
